export default __webpack_public_path__ + "static/media/discord.c0c58ff1.svg";